import {TextButton} from '../../index'

const OverrideApprovalButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick} variant={'contained'}>Override Approval</TextButton>
    )
}

export default OverrideApprovalButton